// src/i18n/locale.js — read/set active UI locale outside React components.
import i18n, { SUPPORTED_LOCALES, LOCALE_STORAGE_KEY } from './index.js';

/** BCP-47 tag for Intl.* APIs based on the active UI language. */
export function getActiveLocale() {
  const lng = (i18n.language || 'it').split('-')[0];
  return lng === 'en' ? 'en-US' : 'it-IT';
}

/**
 * Output-language code ('it' | 'en') derived from the active UI selector.
 * This is the single source of truth for the content-generation language:
 * fed as `?language=` on the persona/objective pickers and as `language` in
 * the POST /pipeline/run brief body. Defaults to 'it'.
 */
export function getOutputLanguage() {
  return (i18n.language || 'it').split('-')[0] === 'en' ? 'en' : 'it';
}

export function setLocale(lng) {
  if (!SUPPORTED_LOCALES.includes(lng)) return;
  try { localStorage.setItem(LOCALE_STORAGE_KEY, lng); } catch { /* private mode */ }
  i18n.changeLanguage(lng);
}

/**
 * Seed the UI language from the ACCOUNT when this browser has no explicit
 * choice of its own.
 *
 * ⛔ Why this exists: i18n detection is `order: ['localStorage']` with
 * `fallbackLng: 'it'`, so nothing ever read `users.locale`. Syncing only
 * UI → server left a fresh browser showing Italian while the account (and
 * therefore every transactional email) said English. An explicit per-device
 * choice still WINS — this only fills the gap.
 *
 * ⚠️ Relies on `detection.caches: []` in ./index.js: with i18next's default
 * cache on, every changeLanguage (and the fallback at init) wrote localStorage,
 * so a browser ALWAYS looked like it had chosen and this never fired.
 */
export function seedLocaleFromUser(userLocale) {
  let stored = null;
  try { stored = localStorage.getItem(LOCALE_STORAGE_KEY); } catch { /* private mode */ }
  if (stored) return;                       // the device chose — leave it alone
  if (!SUPPORTED_LOCALES.includes(userLocale)) return;
  i18n.changeLanguage(userLocale);          // ⛔ NOT setLocale: do not write
}                                           //    localStorage, or the next
                                            //    account change is ignored
